import { clamp } from '@frontend/utils/math';
import { Box, BoxProps } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

export interface AppearOnScrollProps extends BoxProps {
  percent: number;
  children: React.ReactNode;
}

export function AppearOnScroll(props: AppearOnScrollProps) {
  const ref = useRef(null);
  const [didAppear, setDidAppear] = useState(false);

  const onWindowScroll = () => {
    if (!ref.current) {
      return;
    }
    const rect = ref.current.getBoundingClientRect();
    const anchor = rect.top + rect.height * clamp(props.percent || 0, 0, 1);
    if (anchor < window.innerHeight) {
      setDidAppear(true);
    }
  };

  useEffect(() => {
    if (didAppear) return;
    window.addEventListener('scroll', onWindowScroll);
    onWindowScroll();
    return () => {
      window.removeEventListener('scroll', onWindowScroll);
    };
  }, [didAppear]);

  return (
    <Box {...props} ref={ref} className={didAppear && 'didAppear'}>
      {props.children}
    </Box>
  );
}
